export var ignoreEvent = function ignoreEvent(event) {
  var tagName = event.target.tagName;
  if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
    event.stopPropagation();
    return;
  }
  event.preventDefault();
  event.stopPropagation();
};